import { Injectable } from '@angular/core';

import { TranslationCache } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class TranslationCacheService extends TmsWebBaseEditService<TranslationCache, TranslationCache> {
  constructor() {
    super('TranslationCache', $localize`Translation`);
  }
}
